import { Body, Card, VBadge, cn } from '@vrzl/ui';

import type { ValidationReportItem } from '../api/types';

import { ValidationCriterionRow } from './validationCriterionRow';

export type StatusColumnVariant = 'found' | 'missing';

const VARIANTS = {
  found: {
    title: 'Gevonden inhoud',
    empty: 'Niets gevonden in dit onderwerp.',
    panel: 'border-success-200',
    band: 'border-success-200 bg-success-100',
    heading: 'text-success-700',
    count: 'success',
  },
  missing: {
    title: 'Ontbrekende inhoud',
    empty: 'Niets ontbrekend in dit onderwerp.',
    panel: 'border-error-200',
    band: 'border-error-200 bg-error-100',
    heading: 'text-error-700',
    count: 'error',
  },
} as const;

type StatusColumnProps = {
  variant: StatusColumnVariant;
  items: ValidationReportItem[];
  eventId: string;
  sentFeedback: ReadonlySet<string>;
  onFeedbackSent: (criterionId: string) => void;
};

export function StatusColumn({
  variant,
  items,
  eventId,
  sentFeedback,
  onFeedbackSent,
}: StatusColumnProps) {
  const v = VARIANTS[variant];

  return (
    <Card padding="none" className={cn('overflow-hidden', v.panel)}>
      <div className={cn('flex items-center gap-2 border-b px-4 py-3', v.band)}>
        <span className={cn('font-semibold', v.heading)}>{v.title}</span>
        <VBadge color={v.count} shape="pill" className="ml-auto">
          {items.length}
        </VBadge>
      </div>
      <div className="p-4">
        {items.length === 0 ? (
          <Body tone="muted" className="italic">
            {v.empty}
          </Body>
        ) : (
          <ul className="space-y-2">
            {items.map((item) => (
              <ValidationCriterionRow
                key={item.id}
                item={item}
                eventId={eventId}
                feedbackSent={sentFeedback.has(item.id)}
                onFeedbackSent={onFeedbackSent}
              />
            ))}
          </ul>
        )}
      </div>
    </Card>
  );
}
